import Api from "@/services/api";
import { FavoriteDto } from "@/services/favorites/types";

export async function setFavorite(model: FavoriteDto): Promise<any> {
    return new Promise((resolve, reject) => {
        Api.post("/favorite", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
